import { render, staticRenderFns } from "./kolList.vue?vue&type=template&id=36cf878e&scoped=true&"
import script from "./kolList.vue?vue&type=script&lang=js&"
export * from "./kolList.vue?vue&type=script&lang=js&"
import style0 from "./kolList.vue?vue&type=style&index=0&id=36cf878e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf878e",
  null
  
)

export default component.exports